module.exports = __webpack_public_path__ + "static/media/ls01.bda74437.jpg";